import * as React from 'react';
import { useState } from 'react';
import StoreSelect from '../Components/StoreSelect';
import ItemSelect from '../Components/ItemSelect';
import EditRecordForm from '../Components/EditRecordForm';
import { Store } from '../Services/Store/StoreApi';
import { Item } from '../Services/Item/ItemApi';
import { FormControl, Stack } from '@mui/material';
import { Box } from '@mui/system';




export default function ShoppingInput() {
    const [selectedStore, setSelectedStore] = useState<Store | undefined>();
    

    const [selectedItem, setSelectedItem] = useState<Item | undefined>();

    const clearItem = () => setSelectedItem(undefined);

    return (
        <Box sx={{ my: 2 }} >
            <Stack spacing={2}>
                <FormControl fullWidth>
                    <StoreSelect onSelect={setSelectedStore} selected={selectedStore} />
                </FormControl>
                <FormControl fullWidth>
                    <ItemSelect onSelect={setSelectedItem} selected={selectedItem} />
                </FormControl>
                {selectedStore && selectedItem &&
                    <EditRecordForm item={selectedItem} store={selectedStore} onSaved={clearItem} />
                }
            </Stack>
        </ Box>

    );
}

